import {createStyles, makeStyles, Theme} from '@material-ui/core/styles/';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    optumLogoContainer: {
      display: 'flex',
      gap: 'clamp(0.5rem,2vw,30px) !important',
      alignItems: 'center'
    },
    brandImage: {
      objectFit: 'contain',
      height: '38px',
      width: '100% !important'
    },
    navBar: {
      // width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    localImage: {
      height: '48px',
      width: '220px !important',
      objectFit: 'contain'
    },
    homeTitle: {
      color: '#4B4D4F',
      fontSize: '24px !important',
      fontWeight: 400,
      whiteSpace: 'nowrap'
    },
    divider: {
      borderWidth: '1.5px !important',
      backgroundColor: '#B1B2B4 !important',
      height: '30px !important'
    },
    headerContainer: {
      paddingTop: '8px',
      background: '#F8F3F8',
      padding: '20px 35px 20px !important'
    },
    drawerPaper: {
      width: '250px',
      padding: '20px'
    },
    mobileNavItem: {
      width: '100%',
      padding: '12px 0'
    },
    linkText: {
      fontWeight: 'bold',
      fontSize: '16px',
      transition: 'color 0.3s'
    },
    list: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      maxHeight: '40px',
      padding: '0 80px',
      paddingBottom: '0px !important',
      '&.isMobile': {
        flexDirection: 'column',
        alignItems: 'start'
      }
    },
    listItemWrapper: {
      display: 'flex',
      flexDirection: 'row',
      '&.isMobile': {
        flexDirection: 'column'
      }
    },
    listItem: {
      width: 'auto',
      borderBottom: 'none',
      padding: '0',
      '&.active': {
        backgroundColor: '#eff6f9',
        borderBottom: '1px solid #0c55b8'
      },
      '&.isMobile': {
        width: '100%'
      }
    },
    link: {
      textDecoration: 'none',
      padding: '16px',
      '&.isMobileView': {
        textDecoration: '100%'
      },
      '&:hover': {
        backgroundColor: 'unset'
      }
    },
    logoutBtn: {
      cursor: 'pointer'
    },
    userNav: {
      float: 'right',
      position: 'relative',
      height: '32px'
    },
    userNavBtn: {
      float: 'left',
      background: '#fff',
      color: '#002677',
      padding: '3px 20px',
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '20px',
      fontStyle: 'normal',
      fontFamily: theme.typography.fontFamily,
      margin: 0,
      border: 0,
      borderRadius: 0,
      boxShadow: 'none',

      '& .button-label': {
        borderBottom: '1px solid transparent'
      },
      '&:hover, &.active': {
        background: '#fff',
        color: '#002677',
        border: 0,
        boxShadow: 'none',
        '& .button-label': {
          borderBottom: `1px solid transparent`
        }
      }
    },
    userNavCollapse: {
      position: `absolute`,
      padding: `10px 0`,
      fontFamily: theme.typography.fontFamily,
      border: `1px solid transparent`,
      background: '#002677',
      zIndex: 1002,
      top: `100%`,
      right: 0,
      display: `inline-flex`,
      width: `100%`,
      maxWidth: `280px`,
      boxShadow: `0px 2px 6px rgb(0 0 0 / 20%)`,

      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '20.25px',
      lineHeight: '24px',

      '& button': {
        padding: `6px 20px`,
        color: '#fff',
        cursor: 'pointer',
        marginBottom: '-10px',
        marginTop: '-10px',
        textAlign: `center`,
        fontWeight: `bold`,
        width: `100%`,
        fontSize: '16px',

        '&:hover': {
          color: '#fff',
          background: '#002677'
        }
      }
    }
  });
});
